/* eslint-disable import/prefer-default-export */
import Store from '@/store/index';

export function hasPermissions(...permissions: string[]): boolean {
  const ExistingPermissions = Store.state.User.Permissions;
  return permissions.every((perm) => ExistingPermissions.includes(perm));
}
